import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-gif-image',
  templateUrl: './loading-gif-image.component.html',
  styleUrls: ['./loading-gif-image.component.scss']
})
export class LoadingGifImageComponent {

}
